const getAllYears = () => {
  return Array.from(
    { length: 2099 - 1900 + 1 },
    (_, index) => 1900 + index
  ).map((year) => ({ Key: year, Value: year }));
};

const getFutureYears = () => {
  return Array.from(
    { length: 2099 - new Date().getFullYear() + 1 },
    (_, index) => new Date().getFullYear() + index
  ).map((year) => ({ Key: year, Value: year }));
};

const getPastYears = () => {
  return Array.from(
    { length: new Date().getFullYear() - 1900 + 1 },
    (_, index) => 1900 + index
  ).map((year) => ({ Key: year, Value: year }));
};

const getPastYearsDescending = () => {
  return Array.from(
    { length: new Date().getFullYear() - 1900 + 1 },
    (_, index) => 1900 + index
  )
    .reverse()
    .map((year) => ({ Key: year, Value: year }));
};

export {
  getAllYears,
  getFutureYears,
  getPastYears,
  getPastYearsDescending,
};
